import { applyStyles } from '../../utils/styleUtils';
import { useOnboarding } from '../../context/OnboardingContext';

const ImageElement = ({ element }) => {
    const style = applyStyles(element);
    const { replaceTemplates } = useOnboarding();
    const url = replaceTemplates(element.url);
    const className = `element-image ${element.large || element.url.includes('nEqGKV') ? 'large' : ''}`;

    function isDesktop() {
        const minWidth = 768; // Minimum width for desktop devices
        return window.innerWidth < minWidth || screen.width < minWidth;
    }

    if (isDesktop() && element.onlyForDesktop) {
        console.log("Desktop device detected");
        return null;
    }

    return (
        <img
            className={className}
            src={url}
            alt={element.alt || ''}
            style={style}
        />
    );
};

export default ImageElement;

